import {
  AnswerContent,
  SpaceContent,
  SpaceType,
  TableThContent,
  TableContent,
  TableType,
  TextContent,
  TableTdContent,
} from '@/resource/question/question.type';

const th = new TableThContent([
  new TextContent('Question here'),
  new TextContent('Answer here'),
]);

const td1 = new TableTdContent([
  new TextContent('First question'),
  new AnswerContent(
    [new SpaceContent(SpaceType.Empty, 100, 200)],
    [new TextContent('First answer')],
  ),
]);

const td2 = new TableTdContent([
  new TextContent('Second question'),
  new AnswerContent(
    [new SpaceContent(SpaceType.Empty, 100, 200)],
    [new TextContent('Second answer')],
  ),
]);

const tableExample = new TableContent([th, td1, td2], TableType.Border);

export default tableExample;
